import * as React from 'react'
// libs
import { MessagePrimitive } from '@assistant-ui/react'
// components
import SentAttachmentChip from '../SentAttachmentChip'
// views
import { UserBubble } from './views'

const UserMessage: React.FC = () => (
  <UserBubble>
    <MessagePrimitive.Attachments components={{ Attachment: SentAttachmentChip }} />
    <MessagePrimitive.Parts
      components={{
        Text: ({ text }: { text: string }) => <span>{text}</span>
      }}
    />
  </UserBubble>
)

export default UserMessage
